export const rbaGoesOnline = {
  "id": "rba-goes-online-2025",
  "title": "Der RBA geht online: Ein neues Kapitel für die Bundesliga",
  "slug": "rba-goes-online-neues-kapitel-bundesliga",
  "publishedAt": "2025-06-25T10:00:00Z",
  "author": "Rugby Bundesliga Redaktion",
  "language": "de",
  "readTime": "5 min",
  "tags": ["Rugby", "Bundesliga", "Digital", "Website", "RBA"],
  "excerpt": "Die Rugby Bundesliga bekommt ein neues digitales Zuhause.",
  "img": "/images/rba-goes-online-2025.jpeg",
  "blocks": [
    {
      "type": "paragraph",
      "content": "Die Rugby Bundesliga bekommt ein neues digitales Zuhause."
    },
    {
      "type": "paragraph",
      "content": "Wir, der Rugby Bundesliga Ausschuss (RBA), präsentieren mit Stolz die erste offizielle Website zur Rugby Bundesliga und damit mehr als nur eine neue Internetseite. Sie ist ein sichtbares Zeichen für den Aufbruch in eine neue Ära der Öffentlichkeitsarbeit, in der Transparenz, Reichweite und Zugänglichkeit endlich den Stellenwert erhalten, den sie im Spitzensport verdienen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Ein notwendiger Schritt"
    },
    {
      "type": "paragraph",
      "content": "Lange Zeit fehlte es der Rugby Bundesliga an einer eigenen, zentralen Plattform, auf der sich alle Interessierten über Ergebnisse, Entwicklungen, Strukturen und Stimmen informieren konnten. Diese Lücke schließen wir jetzt mit einem Webauftritt, der das Herz des Liga-Geschehens digital abbildet."
    },
    {
      "type": "paragraph",
      "content": "Der Launch dieser Seite ist für uns kein Endprodukt, sondern ein Anfang: Die Plattform befindet sich im Aufbau und wird kontinuierlich erweitert. In Anbetracht der Dringlichkeit, eine funktionierende Anlaufstelle bereitzustellen, haben wir bewusst entschieden, die Website bereits im jetzigen Zustand zu veröffentlichen. Unsere Nutzerinnen und Nutzer dürfen sich auf regelmäßige Updates, neue Funktionen und wachsende Inhalte freuen."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Mehr als nur eine Website, unser digitaler Beitrag zur Bundesliga"
    },
    {
      "type": "paragraph",
      "content": "Unser digitaler Neustart wird begleitet von einer intensivierten Social-Media-Strategie:"
    },
    {
      "type": "list",
      "ordered": "false",
      "items": [
        "Auf Instagram und Facebook bieten wir ab sofort mehr Inhalte, mehr Nähe und mehr Kommunikation.",
        "Aktuell arbeiten wir an einem eigenen YouTube-Kanal, auf dem alle Spiele der 1. Rugby Bundesliga abrufbar sein sollen. Damit schaffen wir erstmals eine zentrale Videoplattform für die Liga.",
        "Zusätzlich planen wir, künftig mindestens ein „Highlight-Spiel der Woche\" professionell zu produzieren und im Livestream anzubieten. Ein Format, das nicht nur sportlich, sondern auch medial ein neues Kapitel für die Bundesliga aufschlägt."
      ]
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Wir schließen die Informationslücke von Rugbyweb"
    },
    {
      "type": "paragraph",
      "content": "Mit dem Ende von Rugbyweb.de ist eine wichtige Informationsquelle für die Rugby-Community weggefallen. Wir erkennen diese Lücke und wir wollen sie bewusst füllen. Unsere Website soll daher nicht nur eine Plattform für die 1. Bundesliga sein, sondern auch ein Ort, an dem Ergebnisse und Tabellen aus dem gesamten deutschen Rugby ihren Platz finden."
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Was euch auf der Website erwartet"
    },
    {
      "type": "paragraph",
      "content": "Auch wenn wir noch lange nicht fertig sind, bildet die Seite schon jetzt zentrale Elemente ab:"
    },
    {
      "type": "list",
      "listType": "unordered",
      "items": [
        "Ergebnisse, Tabellen und Spielpläne der 1. und 2. Bundesliga sowie der Regionalligen",
        "Informationen zu uns als RBA und zur Ligastruktur",
        "Kontaktmöglichkeiten für Vereine, Medien und Interessierte",
        "Verlinkungen zu unseren Social-Media-Kanälen",
        "Zukünftig: Ergebnisse der Jugend- und Frauenligen, Videoinhalte, Statistiken, Archivmaterial und vieles mehr"
      ]
    },
    {
      "type": "heading",
      "level": 2,
      "content": "Gemeinsam in die Zukunft der Bundesliga"
    },
    {
      "type": "paragraph",
      "content": "Mit dieser Website wird ein lang gehegter Wunsch Realität und ein klarer Anspruch formuliert: Die Rugby Bundesliga verdient Sichtbarkeit, Struktur und moderne Kommunikation. Wir nehmen diese Verantwortung an und laden die Rugby-Community ein, diesen Weg gemeinsam mit uns zu gehen über alle Ligen hinweg."
    },
    {
      "type": "paragraph",
      "content": "Noch ist nicht alles perfekt, aber der Grundstein ist gelegt."
    },
    {
      "type": "paragraph",
      "content": "Willkommen auf der offiziellen Seite der Rugby Bundesliga. Willkommen bei uns."
    },
    {
      "type": "callout",
      "variant": "info",
      "title": "Mach mit und gestalte die Zukunft der Bundesliga mit uns!",
      "content": "Dieser digitale Neustart ist nur der Anfang und wir wissen: Eine lebendige Plattform lebt vom Mitmachen. Ob du Ideen für Inhalte hast, journalistisch arbeiten möchtest, dich mit Grafik, Video oder Social Media auskennst oder einfach helfen willst, die Rugby Bundesliga digital noch besser zu machen, wir freuen uns über jede Form der Unterstützung."
    },
    {
      "type": "paragraph",
      "content": "Du möchtest dich einbringen? Kreativ, technisch oder organisatorisch? Dann melde dich bei uns! Gemeinsam können wir die mediale Präsenz der Rugby Bundesliga auf ein neues Level heben."
    },
    {
      "type": "paragraph",
      "content": "rba-vorsitz@rugbydeutschland.org 📧",
    },
    {
      "type": "paragraph",
      "content": "Werde Teil der Entwicklung. Werde Teil des Teams. Für eine starke Bundesliga, auf dem Platz und im Netz.",
      "emphasis": "strong"
    }
  ]
}
